import { useUser } from "../use-user";

export const useFreelancerId = (): number | null => {
  const user = useUser();

  return user?.freelancer || null;
};
